/**
 * View mode type for chart panel tabs.
 */
export type ViewMode = 'graph' | 'grid';

/**
 * Generates a download filename from a panel title.
 * Trims whitespace, converts to lowercase, replaces spaces with hyphens, appends `.png`.
 *
 * @example
 * generateDownloadFilename("Total Enrollment Over Time") // "total-enrollment-over-time.png"
 */
export function generateDownloadFilename(title: string): string {
  return `${title.trim().toLowerCase().replace(/\s+/g, '-')}.png`;
}

/**
 * Downloads the chart canvas inside the given container as a PNG image.
 * Creates a temporary anchor element to trigger the browser download, then cleans up.
 *
 * @param chartContainerRef - The container div that holds the chart canvas
 * @param filename - The desired download filename
 */
export function downloadChartAsImage(
  chartContainerRef: HTMLDivElement | null,
  filename: string
): void {
  if (!chartContainerRef) return;

  const canvas = chartContainerRef.querySelector('canvas');
  if (!canvas) return;

  try {
    const dataUrl = canvas.toDataURL('image/png');
    const anchor = document.createElement('a');
    anchor.href = dataUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } catch (error) {
    console.error('Failed to download chart as image:', error);
  }
}
